import { Asset as IAsset, ProductVariant} from "../../components/contracts/types";
import {numberToCurrency,imgpath} from "../../services/globals";
import { ProductAttribute } from "./ProductAttribute";
import PlaceCartComponent from '../../components/placecart'

export interface IProductAttr {
  key: string;
  values: Array<string>;
}

export default function ProductView ({ product, func}) {
   const title = product.name;
  const description = product.description;
  //console.log(product.variants[0].priceWithTax);

  const fprice = numberToCurrency(product.variants[0].priceWithTax);
  const img = imgpath(product.assets[0].source);

  function handleSelect(select: string) {
    let id = (document.getElementById(select) as HTMLInputElement).value;
    let idnr:number = parseInt(id)
    let element = document.getElementsByClassName("incartbutton")[0]; //kommt auf der Detailseite nur einmal vor
    if (idnr > 0) {
      element.classList.remove("disabled");
    } else {
      element.classList.add("disabled");
    }
    
    //alert("changeSelect");
  }


  if (product.variantList.totalItems == 1) {
  return (
    <div className="row">
    <div className="col-md-7">
        <img className="img-fluid img-thumbnail" src={img} alt={product.name}></img>
     </div> 
      <div className="col-md-5">
        <h3>{title}</h3> 
        <div dangerouslySetInnerHTML={{__html:description}}/>
        {fprice}
        <div> <PlaceCartComponent idnr={product.variants[0].id}  qty="1" func={func} select={null}></PlaceCartComponent> </div>
        </div>
    </div>
  );
  } else {
    let index:number = 0;
    return (
      <div className="row">
    <div className="col-md-7">
        <img className="img-fluid img-thumbnail" src={img} alt={product.name}></img>
     </div> 
      <div className="col-md-5">
        <div dangerouslySetInnerHTML={{__html:description}}/>
        <select id="selectvariants" onChange={() => {handleSelect("selectvariants");}}>
        <option value="0">Bitte auswählen</option>
        { 
          product.variants.map(function(vari,i) {
            //console.log(vari.priceWithTax);
            let fprice = numberToCurrency(vari.priceWithTax);
            return (<option value={vari.id} key={vari.id}>{vari.name} - {fprice}</option>)
        })  
        }
      </select>
      <div> <PlaceCartComponent  idnr="0"  qty="1" func={func} select="selectvariants"></PlaceCartComponent> </div>
      </div>

      </div>

    );
  }
};
